// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7b50bf1d","239":"f7dfb924","455":"4d2b6464"}[chunkId] + ".chunk.js";
};